var _rect, _path, _rect2, _rect3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcnPatternOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 4.75977,
    width: 30.6746,
    height: 30.6746,
    rx: 3,
    stroke: "currentColor",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.6409 24.524C40.1959 22.0789 40.1959 18.1147 42.6409 15.6696L55.4767 2.83381C57.9218 0.38873 61.8861 0.38873 64.3311 2.83381L77.1669 15.6696C79.612 18.1147 79.612 22.0789 77.1669 24.524L64.3311 37.3598C61.8861 39.8049 57.9218 39.8049 55.4767 37.3598L42.6409 24.524Z",
    stroke: "currentColor",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 48.3252,
    width: 30.6746,
    height: 30.6746,
    rx: 3,
    stroke: "currentColor",
    strokeWidth: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 44.5669,
    y: 48.3252,
    width: 30.6746,
    height: 30.6746,
    rx: 3,
    stroke: "currentColor",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnPatternOutline);
export default __webpack_public_path__ + "static/media/icn-pattern-outline.440339815425a53a9a6104f0b5299169.svg";
export { ForwardRef as ReactComponent };